module.exports = __webpack_public_path__ + "img/chakandingdan.2624b97c.png";